import axios from 'axios'
import { getHeaders } from '@/tools/utils.js'

axios.defaults.baseURL = process.env.VUE_APP_API_URL

const prefix = '/distributors'

export default {

  async search () {
    const headers = await getHeaders()
    return axios.get(prefix, { headers: headers })
  },

  async detail (criterias) {
    const headers = await getHeaders()
    return axios.post(prefix + '/detail', criterias, { headers: headers })
  },

  async update (criterias) {
    const headers = await getHeaders()
    return axios.post(prefix + '/update', criterias, { headers: headers })
  }
}
